'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Reach = require('lodash.get');

var internals = {};

/**
 * Commission calculation class
 *
 * @type {module.Commission}
 */
module.exports = function () {
    function Commission() {
        _classCallCheck(this, Commission);
    }

    _createClass(Commission, null, [{
        key: 'match',


        /**
         * Matches a mandate to it's correct commission
         *
         * @param commission Commission object as defined in the mandate service
         * @param mandate An object as defined containing: typeId, address.postcode, price, user.groups (either mandate or avenant object)
         * @param price Price to calculate match against
         * @returns {*}
         */
        value: function match(commission, mandate, price) {

            return internals.match(commission, mandate, price);
        }

        /**
         * Validates the pricing object against a match
         *
         * @param match The result of calling Commission.match
         * @param price the price as a number
         * @param fees the fees as a number
         * @returns {boolean} true if fees are valid, false otherwise
         */

    }, {
        key: 'validate',
        value: function validate(match, price, fees) {

            return internals.calculateValue(price, match) >= fees;
        }

        /**
         * Calculate value for given match & price
         *
         * @param match
         * @param price
         * @returns {*}
         */

    }, {
        key: 'calculate',
        value: function calculate(match, price) {

            return internals.calculateValue(price, match);
        }
    }, {
        key: 'operations',
        get: function get() {

            return internals.operations;
        }
    }, {
        key: 'validations',
        get: function get() {

            return internals.validations;
        }
    }]);

    return Commission;
}();

internals.operations = {
    eq: function eq(value, expected) {
        return value === expected;
    },
    ne: function ne(value, expected) {
        return value !== expected;
    },
    lt: function lt(value, expected) {
        return value < expected;
    },
    lte: function lte(value, expected) {
        return value <= expected;
    },
    gt: function gt(value, expected) {
        return value > expected;
    },
    gte: function gte(value, expected) {
        return value >= expected;
    }
};

internals.check = function (value, operation, expected) {

    if (value === undefined) {
        return false;
    }

    var validator = Reach(internals.operations, operation, false);

    return validator(value, expected);
};

internals.validations = {
    mandateType: function mandateType(mandate, price, operation, value) {
        return internals.check(Reach(mandate, 'typeId'), operation, value);
    },
    id: function id(mandate, price, operation, value) {
        return internals.check(Reach(mandate, 'id'), operation, value);
    },
    price: function price(mandate, _price, operation, value) {
        return internals.check(_price, operation, value);
    },
    group: function group(mandate, price, operation, value) {

        return Reach(mandate, 'user.groups', []).reduce(function (a, c) {
            return a || internals.check(c.id || c, operation, value);
        }, false);
    },
    postcode: function postcode(mandate, price, operation, value) {
        return internals.check(Reach(mandate, 'address.postcode'), operation, value);
    },
    postcodes: function postcodes(mandate, price, operation, value) {

        var postcode = Reach(mandate, 'address.postcode');

        return value.split(',').reduce(function (acc, c) {

            return acc || internals.check('' + postcode, operation, c.trim());
        }, false);
    },
    insee: function insee(mandate, price, operation, value) {
        return internals.check(Reach(mandate, 'address.insee'), operation, value);
    },
    insees: function insees(mandate, price, operation, value) {

        var insee = Reach(mandate, 'address.insee');

        return value.split(',').reduce(function (acc, c) {

            return acc || internals.check('' + insee, operation, c.trim());
        }, false);
    }
};

internals.match = function (commission, mandate, price) {

    if (!commission.rules) {

        throw new Error('rules must be defined on commission');
    }

    if (!commission.default) {

        throw new Error('default must be defined on commission');
    }

    var match = commission.rules.find(function (rule) {

        return rule.conditions.reduce(function (acc, condition) {

            var validator = Reach(internals.validations, condition.type, false);

            return acc && validator(mandate, price, condition.operation, condition.value);
        }, true);
    });

    if (match) {
        return match;
    }

    return commission.default;
};

internals.calculateValue = function (price, commission) {

    if (commission.type === 'fixed') {
        return commission.value;
    }

    return Math.floor(price * commission.value / 100);
};